export const pricingTranslations = {
  pricingPlan: {
    en: 'Our pricing plan',
    fr: 'Notre plan tarifaire'
  },
  clearSimple: {
    en: 'Clear and simple',
    fr: 'Clair et simple'
  },
  perUserPerMonth: {
    en: 'Per user per month',
    fr: 'Par utilisateur par mois'
  },
  supercharge: {
    en: 'Supercharge the creation of your organizations diagrams with :',
    fr: 'Complétez la création des diagrammes de vos organisations avec :'
  },
  unlimitedDiagrams: {
    en: 'Unlimited org charts',
    fr: 'Organigrammes illimités'
  },
  sharedDiagrams: {
    en: 'Shared org charts between colleagues',
    fr: 'Organigrammes partagés entre collègues'
  },
  customStyling: {
    en: 'Custom styling added to your graphs',
    fr: 'Vos graphiques personnalisés'
  },
  unlimitedEntities: {
    en: 'Unlimited entities per org chart',
    fr: 'Entités illimitées par organigramme'
  },
  backedUp: {
    en: 'Safely backed up work',
    fr: 'Travail sauvegardé en toute sécurité'
  },
  fastWorkflow: {
    en: 'Fast and efficient workflow',
    fr: 'Flux de travail rapide et efficace'
  },
  dailyCoffee: {
    en: 'All those awesome features for less than the price of a daily coffee',
    fr: "Toutes ces fonctionnalités géniales pour moins que le prix d'un café quotidien"
  },
  readyStart: {
    en: 'Ready to start?',
    fr: 'Prêt à commencer?'
  },
  createAccount: {
    en: 'Create an account',
    fr: 'Créer un compte'
  }
}

export default pricingTranslations
